import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'
import { t } from 'src/utils/form'
import csv from 'src/utils/csv'
import date from 'src/utils/date'

export const loadContracts = (context, payload) => {
  return actions.getContracts(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setContracts, response.data.contracts)
      context.commit(setPagination, response.data.meta)
    }
    return response
  })
}

export const getCsvContracts = (context, payload) => {
  return actions.getContractsCsv(payload).then(function (response) {
    if (response.data) {
      csv.download(response.data, t(context, 'contracts.formats.csv', {today: date.parseDefaultDate(new Date(), '-'), subdomain: window.location.host.split('.')[0]}))
      context.commit(addFlash, { message: t(context, 'contracts.alerts.report_generated'), type: 'ls-alert-success' })
    } else {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'contracts.alerts.report_sent', {email: JSON.parse(window.localStorage.getItem('user')).email}),
          type: 'ls-alert-success' })
      }
      return response
    }
  })
}

export const loadSetting = (context, payload) => {
  return actions.getSetting(payload)
  .then((response) => {
    return response
  })
}

export const editContractSetting = (context, payload) => {
  return actions.updateSetting(payload)
  .then((response) => {
    return response
  })
}

export const loadContract = (context, payload) => {
  return actions.getContract(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setContract, response.data.contract)
    }
    return response
  })
}

export const generateNextInvoice = (context, payload) => {
  return actions.createNextInvoice(payload)
  .then(function (response) {
    return response
  })
}

export const loadContractPlan = (context, payload) => {
  return actions.getContractPlan(payload)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.setContractPlan, response.data.contract)
      }
      return response
    })
}

export const editContract = (context, payload) => {
  return actions.updateContract(payload)
  .then(function (response) {
    if (response.status === 200) {
      context.commit(addFlash, { message: t(context, 'contracts.edit.alerts.success.plan_changed', { id: payload.contract.id }), type: 'ls-alert-success' })
    }
    return response
  })
}

export const updateContract = (context, payload) => {
  return actions.editContract(payload)
  .then(function (response) {
    return response
  })
}

export const inactiveContract = (context, payload) => {
  return actions.destroyContract(payload.contract)
  .then(function (response) {
    if (response && response.status === 200) {
      if (typeof payload.index === 'undefined') {
        context.commit(addFlash, { message: t(context, 'contracts.alerts.inactivated_contract', { id: response.data.contract.id }), type: 'ls-alert-success' })
        context.commit(types.setContract, response.data.contract)
      } else {
        context.commit(types.setContractAfterInactive, { 'index': payload.index, 'contract': response.data.contract })
      }
    }
    if (payload.index === 'undefined') return response
    return { resp: response, payload: payload }
  })
}

export const inactivateDebit = (context, payload) => {
  return actions.cancelDebit(payload)
  .then(function (response) {
    return response
  })
}

export const showLogs = (context, payload) => {
  return actions.captureLogs(payload)
  .then(function (response) {
    return response
  })
}

export const createContract = (context, payload) => {
  return actions.newContract(payload)
  .then(function (response) {
    if (response && response.status === 201) {
      context.commit(types.setContract, response.data.contract)
      context.commit(addFlash, {message: t(context, 'contracts.alerts.create_success'), type: 'ls-alert-success'})
    } else {
      context.commit(addFlash, { message: t(context, 'contracts.alerts.create_fail'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const createContractTax = (context, payload) => {
  return actions.setTax(payload)
  .then((response) => {
    return response
  })
}

export const inactivateContractTax = (context, payload) => {
  return actions.inactivateContractTax(payload)
  .then((response) => {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/contracts/vuex/actions.js